import c from "../common";

export default {
  title: "廣告",
  text1: "排序",
  text2: "標題",
  text3: "可見",
  text4: "隱藏",
  text5: "描述",
  text6: "網址",
  text7: "請提供標題",
  text8: "請提供封面圖",
  text9: "選擇廣告檢視詳情",
  text10: "詳情",
  text11: "創建",
  text12: "取消變更",
  text13: "儲存",
  text14: "確定刪除此廣告? 此動作無法復原",
  text15: "刪除",
  text16: "標題 (必填)",
  text17: "時間",
  text18: "清除時間",
  text19: "取消變更?",
  text20: "返回",
  text21: "封面圖 (必填)",
  text22: "廣告是否可見",
  text23: "宣傳圖",
  text24: "相關商店",
  text25: "新增相片",
  text26: "上限4張已滿",
  text27: "上限為4張",
  text28: "搜尋商店名稱",
  text29: "成功創建",
  text30: "已刪除",
  text31: "更新成功",

};
